import { render, staticRenderFns } from "./field_list.vue?vue&type=template&id=48141fc0&scoped=true"
import script from "./field_list.vue?vue&type=script&lang=js"
export * from "./field_list.vue?vue&type=script&lang=js"
import style0 from "./field_list.vue?vue&type=style&index=0&id=48141fc0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48141fc0",
  null
  
)

export default component.exports